export const NATIVE_ELE_PKG = 'native';

export const CONTAINER_TYPE = {
  COMPONENT: 'Component',
  BLOCK: 'Block',
  PAGE: 'Page',
};

export const SUPPORT_SCHEMA_VERSION_LIST = ['0.0.1', '1.0.0'];

export * from './file';
export * from './generator';
